import { RiDeleteBinLine } from "react-icons/ri";
import { RxCross1 } from "react-icons/rx";
import { Button, Col, Label, Modal, ModalBody, Row } from "reactstrap";
import { useTranslation } from "../../languages";
import ImageUploadInput from "../inputs/ImageUploadInput";
import LabeledCheckedInput from "../inputs/LabeledCheckedInput";
import NormalInput2 from "../inputs/NormalInput2";

const AddDeals = ({
  isOpen,
  setisOpen,
  edit,
  dealData,
  setDealData,
  //all functions

  handleClearData,
  onPressDoneBtn,
  onPressEditBtn,
  handleDaysSelect,
}) => {
  //all local states
  const { t } = useTranslation();
  return (
    <Modal
      size="xl"
      centered
      isOpen={isOpen}
      toggle={() => setisOpen((prev) => !prev)}
    >
      <ModalBody className="bg-white p-4" style={{ borderRadius: "15.22px" }}>
        <div className="d-flex align-items-center white justify-content-between">
          <Button
            onClick={() => setisOpen(false)}
            className="rounded-white-btn border-none p-0 text-black"
            style={{ "--radius": "47px" }}
          >
            <RxCross1 strokeWidth={"1px"} size={17} />
          </Button>
          <h4 className="m-0 figma-shadowed-black-text f-6">
            {edit ? t("edit") : t("add")} {t("deal")}
          </h4>
          <Button
            onClick={() => handleClearData()}
            className="rounded-white-btn border-none p-0 text-black"
            style={{ "--radius": "47px" }}
          >
            <RiDeleteBinLine size={25} />
          </Button>
        </div>
        <Row className="mt-2 gy-3 gx-4">
          <Col md={6}>
            <NormalInput2
              labelClassName="figma-input-label-2"
              label={`${edit ? t("edit") : t("add")} ${t("title")}`}
              placeholder={t("pleaseEnterTitle")}
              value={dealData?.title}
              type={"text"}
              setValue={(v) => setDealData((prev) => ({ ...prev, title: v }))}
            />
          </Col>
          <Col md={6}>
            <NormalInput2
              labelClassName="figma-input-label-2"
              label={t("itemName")}
              placeholder={t("pleaseEnterItemName")}
              value={dealData?.itemName}
              type={"text"}
              setValue={(v) =>
                setDealData((prev) => ({ ...prev, itemName: v }))
              }
            />
          </Col>

          <Col md={6}>
            <NormalInput2
              labelClassName="figma-input-label-2"
              label={t("description")}
              placeholder={t("writeDescription")}
              value={dealData?.description}
              type={"text"}
              setValue={(v) =>
                setDealData((prev) => ({ ...prev, description: v }))
              }
            />
          </Col>
          <Col md={6}>
            <NormalInput2
              labelClassName="figma-input-label-2"
              label={t("price")}
              placeholder={t("writeDealPrice")}
              value={dealData?.price}
              type={"number"}
              setValue={(v) => setDealData((prev) => ({ ...prev, price: v }))}
            />
          </Col>
          <Col md={6}>
            <NormalInput2
              type={"date"}
              value={dealData?.startDate}
              setValue={(v) =>
                setDealData((prev) => ({ ...prev, startDate: v }))
              }
              label={t("startDate")}
              labelClassName={"figma-input-label-2"}
              placeholder={t("selectDate")}
            />
          </Col>
          <Col md={6}>
            <NormalInput2
              type={"date"}
              label={t("endDate")}
              value={dealData?.endDate}
              setValue={(v) => setDealData((prev) => ({ ...prev, endDate: v }))}
              labelClassName={"figma-input-label-2"}
              placeholder={t("selectDate")}
            />
          </Col>
          <Col md={6}>
            <NormalInput2
              type={"time"}
              label={t("from")}
              value={dealData?.from}
              setValue={(v) => setDealData((prev) => ({ ...prev, from: v }))}
              labelClassName={"figma-input-label-2"}
              placeholder={t("from")}
            />
          </Col>
          <Col md={6}>
            <NormalInput2
              type={"time"}
              label={t("to")}
              value={dealData?.to}
              setValue={(v) => setDealData((prev) => ({ ...prev, to: v }))}
              labelClassName={"figma-input-label-2"}
              placeholder={t("to")}
            />
          </Col>
          <Col md={12}>
            <Label className=" figma-input-label-2 m-0">{t("every")}</Label>

            <Row className="g-3 mt-0">
              {dealData?.days?.map((item, k) => (
                <Col md={4} xl={3} key={k}>
                  <LabeledCheckedInput
                    iconSize={30}
                    iconColor={"rgba(33, 0, 93, 1)"}
                    label={item?.day}
                    value={item?.checked}
                    setValue={(v) => handleDaysSelect(v, k)}
                  />
                </Col>
              ))}
            </Row>
          </Col>
          <Col md={6}>
            <Label className="figma-input-label-2 ">
              {" "}
              {edit ? t("edit") : t("add")} {t("picture")}
            </Label>
            <ImageUploadInput
              id={"deal-image"}
              setValue={(v) => setDealData((prev) => ({ ...prev, image: v }))}
              value={dealData?.image}
            />
          </Col>
          <Col md={6} className="d-flex align-items-end px-5">
            <Button
              // onClick={() => setisOpen(false)}
              onClick={() => (edit ? onPressEditBtn() : onPressDoneBtn())}
              className="full-width standard-rounded-btn"
            >
              {edit ? t("update") : t("add")}
            </Button>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default AddDeals;
